// src/store/slices/forgotPasswordSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../../../utils/apiPath";
import { agent } from "../../../../utils/agent";

// ---- FORGOT PASSWORD REQUEST ----
export const forgotPassword = createAsyncThunk(
  "forgotPassword/submit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await agent.post(API.FORGOTPASSWORD, payload);
      return response.data?.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

// ---- INITIAL STATE ----
const initialState = {
  superUserParams: {},
  isForgot: false,
  isSubmitting: false,
  error: null,
};

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    resetForgotState(state) {
      state.isForgot = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(forgotPassword.pending, (state) => {
        state.isSubmitting = true;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state) => {
        state.isSubmitting = false;
        state.isForgot = true;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload;
      });
  },
});

export const { resetForgotState } = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;
